import {v4 as uuidv4} from 'uuid';
import * as Sentry from '@sentry/react';
import {securedFetchRequest} from '@bidmii/common/lib/util/FetchRequest';
import {CDN_URL, API_URL} from '../constants';
import {getStorage, ref, uploadBytes} from 'firebase/storage';
import {firebaseApp} from '../App';

const storage = getStorage(firebaseApp);
export const storeRef = (attachmentReference: $TSFixMe) => {
  return securedFetchRequest(`${API_URL}/attachments`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(attachmentReference),
  });
};

export const deleteRef = (attachmentReference: $TSFixMe) => {
  return securedFetchRequest(
    `${API_URL}/attachments/${attachmentReference.id}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};

export const handleFiles = async (
  event: $TSFixMe,
  onAttach: $TSFixMe,
  attachmentInfo: $TSFixMe,
  files?: $TSFixMe,
) => {
  const uploadPromises = [];
  let attachRef: $TSFixMe;

  const loops = event ? event.currentTarget.files.length : files.length;
  for (let i = 0; i < loops; i++) {
    let file: File;
    if (!files) {
      file = event.currentTarget.files[i];
    } else {
      file = files[i];
    }

    if (loops === 1) {
      // necessary for Google Drive uploads
      const buffer = await file.arrayBuffer();
      const clone = new File([buffer], file.name, {type: file.type});
      file = clone;
    }

    const uid = sessionStorage.getItem('uid');
    const fileUUID = uuidv4();

    const fileParts = file.name.split('.');
    const extension = fileParts[fileParts.length - 1];

    /*
    if (extension.includes('heic')) {
      const blob = await convertToPng(file);
      file = blob as File;
      extension = 'png';
    }
    */

    const storePath = `${uid}/${fileUUID}.${extension}`;
    const fileRef = ref(storage, storePath);

    const metadata = {
      cacheControl: 'max-age=604800',
    };

    const uploadPromise = uploadBytes(fileRef, file, metadata)
      .then(async (snapshot) => {
        const path = storePath.replace('/', '%2F');
        const attachmentReference = {
          name: file.name,
          url: `${CDN_URL}${path}?alt=media&token=${uuidv4()}`,
          firebaseRef: `${uid}/${fileUUID}`,
          ...attachmentInfo,
        };

        try {
          const storeFile = await storeRef(attachmentReference);
          const fileJSON = await storeFile.json();
          attachRef = fileJSON;
        } catch (err) {
          process.env.NODE_ENV === 'development' &&
            console.log('ERROR OCCURRED UPLOADING FILE');
          process.env.NODE_ENV === 'development' && console.error(err);

          Sentry.withScope(function (scope) {
            scope.setTag('section', 'image_upload');
            Sentry.captureException(err);
          });
        }
      })
      .catch((err) => {
        process.env.NODE_ENV === 'development' && console.log('ERROR ERROR');
        process.env.NODE_ENV === 'development' && console.error(err);
        Sentry.withScope(function (scope) {
          scope.setTag('section', 'FileUtils.tsx handleFiles()');
          Sentry.captureException(err);
        });
      });
    uploadPromises.push(uploadPromise);
  }

  let promiseResolved = false;
  Promise.allSettled(uploadPromises)
    .then(() => {
      promiseResolved = true;
      onAttach(attachRef);
    })
    .catch((err) => {
      process.env.NODE_ENV === 'development' &&
        console.log('ERROR ENCOUNTERED UPLOADING FILES');
      process.env.NODE_ENV === 'development' && console.error(err);
      Sentry.withScope(function (scope) {
        scope.setTag('section', 'FileUtils.tsx handleFiles()');
        Sentry.captureException(err);
      });
      promiseResolved = true;
      onAttach();
    });

  setTimeout(function () {
    if (!promiseResolved) {
      process.env.NODE_ENV === 'development' &&
        console.log('EMERGENCY FALLBACK');
      onAttach();
    }
  }, 60000);
};

export const convertBase64 = (
  files: $TSFixMe,
  onConvert: $TSFixMe,
  trim: $TSFixMe,
) => {
  const file = files[0];
  const reader = new FileReader();
  reader.onloadend = () => {
    let base64 = reader.result;
    if (trim) {
      base64 = (base64 as $TSFixMe).substr(
        (base64 as $TSFixMe).indexOf(',') + 1,
      );
    }
    onConvert(base64, file);
  };
  try {
    reader.readAsDataURL(file);
  } catch (e) {
    process.env.NODE_ENV === 'development' &&
      console.error('Could not use reader.readAsDataURL api');
  }
};

export const downloadURI = (uri: $TSFixMe, name: $TSFixMe) => {
  const link = document.createElement('a');
  link.download = name || '';
  link.href = uri;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  link.remove();
};
